var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.preferences.author.logo)?_c('img',{staticClass:"company-logo",attrs:{"src":_vm.logoSrc,"alt":_vm.preferences.author.name}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }